import React from 'react';
import FindOrder from '../../../components/Ecommerce/FindOrder';
import { Link } from 'react-router-dom';

function FindLazadaOrder() {
    const logo = {
        url: '/img/brand-logo/logo-lazada-200.png',
        alt: 'lazada-logo',
    };
    return (
        <FindOrder
            logo={logo}
            title="Nhập mã đơn hàng của bạn"
            description={
                <>
                    Sau 48 giờ kể từ khi đặt hàng, nếu đơn hàng của bạn không hiển thị
                    trên web bạn có thể sử dụng tính năng này để tìm đơn thất lạc. Nếu tìm
                    không thấy tức là đơn hàng không được ghi nhận hoàn tiền. Chi tiết
                    điều khoản xem tại đây:{' '}
                    <Link
                        className="underline text-primary-600 font-semibold"
                        to="/lazada"
                    >
                        https://longhousee.com/lazada
                    </Link>
                </>
            }
            merchant="lazada"
        />
    );
}

export default FindLazadaOrder;
